// extracted by mini-css-extract-plugin
var _1 = "RemainingBoxes_boxContainer__0-NTW";
var _2 = "RemainingBoxes_container__khjCD";
var _3 = "992px";
var _4 = "\"../shared.module.css\"";
export { _1 as "boxContainer", _2 as "container", _3 as "lg", _4 as "shared" }
